package de.oevbs.kunde.kundenportal2.model.services.contact.types

import kotlinx.serialization.Serializable

@Serializable
enum class SolutionProposal(val text: String = "", val key: Int = -1) {
    TROUBLE("Ärger melden",1),
    OFFER("Angebot",2),
    APOLOGY("Entschuldigung / Stellungnahme",3),
    DISCOUNT("Nachlass / günstigerer Preis",4),
    CLARIFICATION("Klärung offener Fragen",5),
    RE_EXAMINATION("Erneute Prüfung",6),
    CALLBACK("Rückruf",7),
    GOODWILL("Kulanz",8),
    CONTRACT_CHANGE("Neuordnung / Vertragsänderung",9),
    QUICK_PROCESSING("Schnelle Bearbeitung",10),
    CANCELLATION("Vertragskündigung / Stornierung",11),
    REBUY("Rückkauf",12),
    CORRESPONDENCE("Schriftwechsel",13),
    CONTRACT_CLEARANCE("Vertragsfreigabe",14),
    DAMAGE_PAYMENT("Zahlung Schaden / Leistung",15),
    DEFERRED_PAYMENT("Stundung / Ratenzahlung",16),
}
